import React from 'react';

type Props = {
  text: string;
  color?: string;
  size?: number;
};

export default function NtaTag({ text, color, size = 12 }: Props) {
  return (
    <span className="badge badge-pill " style={{ backgroundColor: color, fontSize: size }}>
      {text}
    </span>
  );
}
